import React from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import PanelPopup from '../_partials/PanelPopup';
import DesktopLayout from '../_partials/DesktopLayout';
import StripTierPromotion from '../../StripTierPromotion';
import s from './DesktopDeviationPage.scss';
var DesktopDeviationPage = function (_a) {
    var deviation = _a.deviation;
    return (React.createElement(DesktopLayout, { deviation: deviation, stageContent: React.createElement(React.Fragment, null,
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement(StripTierPromotion, { className: s['strip-tier-promotion'], deviation: deviation }),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] })), metaContent: React.createElement(React.Fragment, null,
            React.createElement(Details, { contentClassName: s['details'], deviation: deviation }),
            React.createElement(UserGiftSaleBanner, { user: deviation.author })), withSecondaryActionBar: [DeviationTypes.JOURNAL].includes(getDeviationType(deviation)) }));
};
DesktopDeviationPage.displayName = 'DesktopDeviationPage';
export default DesktopDeviationPage;
//# sourceMappingURL=DesktopDeviationPage.js.map